<template>
  <div/>
</template>

<script>
import { mapState } from 'vuex';
import { Howl } from 'howler';
import { APP_PLAY_SOUND, APP_SHOW_NOTIFICATION } from '@/eventTypes';
import EventBus from '@/eventBus';
import bubbleSoundUrl from '@/assets/sounds/bubble-notification.mp3';
import notificationIcon from '@/assets/images/notification-icon.png';
import notificationBadge from '@/assets/images/notification-badge.png';

export default {
  data() {
    return {
      notificationSound: null,
      permissionStatus: '',
    };
  },
  computed: {
    ...mapState({
      enableSound: (state) => state.playNotificationSound,
    }),
  },
  created() {
    this.initSounds();
    this.askNotificationPermission();

    EventBus.$on(APP_PLAY_SOUND, () => {
      this.playNotification();
    });

    EventBus.$on(APP_SHOW_NOTIFICATION, (title, body) => {
      this.showNotification(title, body);
    });
  },
  destroyed() {
    EventBus.$off(APP_PLAY_SOUND);
    EventBus.$off(APP_SHOW_NOTIFICATION);
  },
  methods: {
    initSounds() {
      this.notificationSound = new Howl({
        html5: true,
        src: [bubbleSoundUrl],
        format: ['mp3'],
      });
    },
    playNotification() {
      if (this.enableSound && this.notificationSound) {
        this.notificationSound.play();
      }
    },
    askNotificationPermission() {
      try {
        Notification.requestPermission().then(
          (permission) => {
            this.permissionStatus = permission;
          },
        );
      } catch (e) {
        Notification.requestPermission(
          (permission) => {
            this.permissionStatus = permission;
          },
        );
      }
    },
    showNotification(title, body) {
      if (('Notification' in window) && this.permissionStatus === 'granted') {
        // eslint workaround for no-param-reassign
        const mainTitle = title;
        const mainBody = body;

        (new Notification(mainTitle, {
          body: mainBody,
          icon: notificationIcon,
          badge: notificationBadge,
          tag: 'appNotificationStack',
          requireInteraction: false,
          renotify: true,
        })).onclick = function doFocus(e) {
          e.preventDefault();
          window.focus();
          this.close();
        };
      }
    },
  },
};
</script>
